/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import { useDispatch, useSelector } from 'react-redux';
import { getInitiativeGroupTree } from '../../selectors/initiativeTree';

import { useCallback } from 'react';
import { RootState } from '../../reducers';
import { loadPortfolioTree } from '../../slice/portfolioTreeSlice';
import Loader from '../../components/loader';
//import InitiativeStructure from "../initiative-structure";
import { portfolioTrackerInitiativeRoutes } from './PortfolioTrackerRoute';
import { useHistory } from 'react-router-dom';
import { generateUrl } from '../util';
import { InitiativeStructureContainer } from '../initiative-structure/InitiativeStructureContainer';

export const PortfolioNavigationMapRoute = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const initiativeTree = useSelector(getInitiativeGroupTree);

  const portfolioTree = useSelector((state: RootState) => state.portfolioTree)

  const onClick = useCallback((portfolioId = '') => {
    const path = generateUrl(portfolioTrackerInitiativeRoutes.PORTFOLIO_TRACKER_PORTFOLIO, { portfolioId });
    history.push(path)
  }, [history])

  if (!portfolioTree.loaded) {
    dispatch(loadPortfolioTree())
    return <Loader />;
  }

  return <InitiativeStructureContainer onClick={onClick} customTree={initiativeTree} isPortfolioTracker />;
}
